"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.technicianLocationsResponseSchema = exports.technicianLocationSchema = exports.technicianLocationJobSchema = exports.locationSharingStatusSchema = exports.locationSharingSessionSchema = exports.technicianPositionRequestSchema = void 0;
const zod_1 = require("zod");
const team_1 = require("./team");
exports.technicianPositionRequestSchema = zod_1.z
    .object({
    latitude: zod_1.z.number().min(-90).max(90),
    longitude: zod_1.z.number().min(-180).max(180),
    accuracyMeters: zod_1.z.number().nonnegative().max(10_000),
    recordedAt: zod_1.z.iso.datetime(),
})
    .strict();
exports.locationSharingSessionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    startedAt: zod_1.z.iso.datetime(),
    expiresAt: zod_1.z.iso.datetime(),
});
exports.locationSharingStatusSchema = zod_1.z.object({
    timezone: zod_1.z.string(),
    canStart: zod_1.z.boolean(),
    workEndsAt: zod_1.z.iso.datetime().nullable(),
    session: exports.locationSharingSessionSchema.nullable(),
});
exports.technicianLocationJobSchema = zod_1.z.object({
    jobId: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int(),
    summary: zod_1.z.string(),
    startAt: zod_1.z.iso.datetime(),
    endAt: zod_1.z.iso.datetime(),
});
exports.technicianLocationSchema = zod_1.z.object({
    technician: team_1.scheduledTeamMemberSchema,
    position: exports.technicianPositionRequestSchema.nullable(),
    freshness: zod_1.z.enum(["FRESH", "STALE", "WAITING"]),
    currentJob: exports.technicianLocationJobSchema.nullable(),
    nextJob: exports.technicianLocationJobSchema.nullable(),
});
exports.technicianLocationsResponseSchema = zod_1.z.object({
    generatedAt: zod_1.z.iso.datetime(),
    timezone: zod_1.z.string(),
    items: zod_1.z.array(exports.technicianLocationSchema),
});
//# sourceMappingURL=technician-location.js.map